// @ts-nocheck
import useIsomorphicLayoutEffect from "@toolkit/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import { RefObject } from "react";

/** Keeps a CSS variable on <html> in sync with the rendered height (px) of the referenced element. */
const usePublishHeightVariable = (ref: RefObject<HTMLElement | null>, variable: string) => {
    useIsomorphicLayoutEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const root = document.documentElement;
        const publishHeight = () => root.style.setProperty(variable, `${element.getBoundingClientRect().height}px`);

        publishHeight();
        const observer = new ResizeObserver(publishHeight);
        observer.observe(element);

        return () => {
            observer.disconnect();
            root.style.removeProperty(variable);
        };
    }, [ref, variable]);
};

export default usePublishHeightVariable;
